export default __webpack_public_path__ + "static/media/52.4016fa72.png";